<template>
  <div>
    <h1>
      <el-page-header @back="goBack" :content="block.name.concat('子类')">
      </el-page-header>
    </h1>
    <div style="margin-bottom: 10px;">
      <el-button type="primary" @click="showDetails('新增子分类')">添加子分类</el-button>
    </div>
    <h1>
      <el-table border max-height="550"
                :data="blocks">
        <el-table-column  label="编号" prop="id"  align="center"></el-table-column>
        <el-table-column  label="名称" prop="name"  align="center"></el-table-column>
        <el-table-column label="显示规则" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-row v-if="scope.row.showStyle===0 " >{{'全部'}}</el-row>
            <el-row v-if="scope.row.showStyle===1 " >{{'国内'}}</el-row>
            <el-row v-if="scope.row.showStyle===2 " >{{'海外'}}</el-row>
          </template>
        </el-table-column>
        <el-table-column  label="图片" width="120px" align="center">
          <template slot-scope="scope">
            <template>
              <img :src="VUE_APP_CDN_URL+scope.row.image" width="60px" height="60px" />
            </template>
          </template>
        </el-table-column>
        <el-table-column  label="介绍" prop="notes"  show-overflow-tooltip align="center"></el-table-column>
        <el-table-column  label="排序"  align="center" width="160px">
          <template slot-scope="scope" >
            <el-input-number size="small" :min="0"  v-model="scope.row.ranking"  @change="updateBlock(scope.row,0)" ></el-input-number>
          </template>
        </el-table-column>
        <el-table-column label="状态" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-button v-if="scope.row.state === true" class="sub-sub" type="success" @click="updateBlock(scope.row,1)">
              已启用
            </el-button>
            <el-button v-if="scope.row.state === false" class="sub-sub" type="danger" @click="updateBlock(scope.row,1)">
              已禁用
            </el-button>
          </template>
        </el-table-column>
        <el-table-column  label="操作"  align="center">
          <template slot-scope="scope">
            <el-button  plain size="mini" type="primary" @click="showDetails('编辑子分类',scope.row)">编辑</el-button>
            <el-button plain size="mini" type="danger" @click="remove(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
        <el-table-column  label="选品"  align="center">
          <template slot-scope="scope">
            <el-button  plain size="mini" type="success" @click="appLinkSelect(scope.row)">去管理</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-dialog :title="dialogTitle" center :visible.sync="dialogVisible" width="600px">
        <el-form :model="blockEditForm" :label-width="labelWidth">
          <el-form-item label="名称:" >
            <el-input  style="width: 300px" type="text" v-model="blockEditForm.name"></el-input>
          </el-form-item>
          <el-form-item label="图片:" :label-width="labelWidth">
            <el-upload
                :headers="headers"
                class="avatar-uploader"
                :action="uploadURL"
                :show-file-list="false"
                :on-success="handleImageSuccess"
                :before-upload="function (file) { return beforeAvatarUpload(file)}"
                @click="uploadImage">
              <img v-if="blockEditForm.image" :src="VUE_APP_CDN_URL+blockEditForm.image" class="avatar">
              <i v-else class="el-icon-picture avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
          <el-form-item label="介绍 :" :label-width="labelWidth">
            <el-input  type="text" v-model="blockEditForm.notes"  ></el-input>
          </el-form-item>
          <el-form-item label="排序 :" :label-width="labelWidth">
            <el-input-number  :min="0"  v-model="blockEditForm.ranking"  ></el-input-number>
          </el-form-item>
          <el-form-item label="展示规则 :" :label-width="labelWidth">
            <el-select v-model="blockEditForm.showStyle" placeholder="请选择">
              <el-option v-for="type in selections.showStyles"
                         :key="type.id"
                         :label="type.name"
                         :value="type.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="状态 :" :label-width="labelWidth">
            <el-radio v-model="blockEditForm.state" :label="false">不显示</el-radio>
            <el-radio v-model="blockEditForm.state" :label="true">显示</el-radio>
          </el-form-item>

          <div style="text-align: center;">
            <el-button type="primary" @click="confirmForm">确 定</el-button>
            <el-button type="info" @click="dialogVisible=false">取 消</el-button>
          </div>
        </el-form>
      </el-dialog>
    </h1>
    <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page.page"
        :page-sizes="[10,20,30]"
        :page-size="page.size"
        layout="total, sizes, prev, pager, next"
        :total="page.totalElements">
    </el-pagination>
  </div>
</template>

<script>
import {
  upload,
  searchBlock,
  selections,
  saveBlock,
  deleteBlock
} from "@/http/iosApi";
export default {
  name: "SecondCategoryManage",
  data(){
    return{
      selections:{},
      VUE_APP_IOS_URL:'',
      VUE_APP_CDN_URL:'',
      headers:{},
      block:{},
      blocks:[],
      labelWidth: '150px',
      uploadURL: process.env.VUE_APP_IOS_URL + "block/upload",
      dialogVisible: false,
      dialogTitle :'',
      blockEditForm: {},
      queryData: {},
      page: {
        size: 10,
        page: 1,
        totalElements: null
      },
      storeObject:{},
    }
  },
  methods:{
    goBack() {
      this.$router.push({path: '/categoryManage'});
    },
    search() {
      this.queryData.size = this.page.size;
      this.queryData.page = this.page.page;
      this.queryData.parentId = this.block.id;
      searchBlock(this.queryData).then(resp => {
        this.blocks = resp.data.info.content;
        this.page.totalElements = resp.data.info.totalElements
      })
    },
    beforeAvatarUpload(file) {
      const isIcon = file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/jpeg'|| file.type === 'image/gif';
      const isLt2M = file.size / 1024 / 1024 < 1;
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过1MB!');
      }
      if (!isIcon) {
        this.$message.error('上传图片只能是png,jgp,jpeg格式!');
      }
      return isIcon && isLt2M;
    },
    handleImageSuccess(response){
      this.blockEditForm.image=response.info;
    },

    handleSizeChange(size) {
      this.page.size = size;
      this.search();
    },
    handleCurrentChange(page) {
      this.page.page = page;
      this.search();
    },
    uploadImage(){
      let func = upload;
      func().then().catch(function () {
      })
    },
    updateBlock(row,position){
      this.blockEditForm = {
        "id" : row.id,
        "parentId":row.parentId,
        "name" :row.name,
        "image" : row.image,
        "notes" : row.notes,
        "ranking" : row.ranking,
        "showStyle":row.showStyle,
        "state": position === 0 ? row.state : !row.state
      };
      this.$confirm('此操作将更改该配置, 是否继续?', '提示', {
        cancelButtonClass: 'btn-custom-cancel',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        saveBlock(this.blockEditForm).then(resp=> {
          if (resp.data.status===0){
            this.search();
          }
        })
      }).catch(() => {
        this.search()
      });
    },
    showDetails(title, row) {
      selections().then(resp => {
        this.selections = resp.data.info;
      })
      this.blockEditForm = {
        "id" : 0,
        "parentId":this.block.id,
        "name" :'',
        "image" : '',
        "notes" : '',
        "ranking" : 0,
        "showStyle":0,
        "state": false

      };

      this.dialogTitle = title;
      this.dialogVisible = true;

      if(row){
        this.blockEditForm = {
          "id" : row.id,
          "parentId":row.parentId,
          "name" :row.name,
          "image" : row.image,
          "notes" : row.notes,
          "ranking" : row.ranking,
          "showStyle":row.showStyle,
          "state":  row.state
        };
      }
    },
    remove(id){
      this.$confirm('此操作将永久删除该配置, 是否继续?', '提示', {
        cancelButtonClass: 'btn-custom-cancel',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteBlock(id).then(resp=> {
          if (resp.data.status === 0) {
            this.search()
          }
        });
      }).catch(() => {
      })
    },
    confirmForm(){
      let _message = '';
      if(this.blockEditForm.name===''){
        _message = '请输入应用名称'
      }else if (this.blockEditForm.showStyle===''){
        _message = '请选择显示类型'
      }
      if(_message){
        this.$message({
          message: _message,
          type: 'error'
        });
        return;
      }
      saveBlock(this.blockEditForm).then(resp => {
        if (resp.data.status === 0 ){
          this.search();
          this.dialogVisible = false;
        }
      });
    },
    appLinkSelect(secondBlock){
      this.storeObject = {
        "id" : secondBlock.id,
        "name" :secondBlock.name,
        "type" : this.block.type

      };
      this.$store.commit('addSecondBlock', this.storeObject);
      this.$router.push({ path: '/selectAppLink'});
    }
  },
  created() {
    this.headers ={Authorization : this.$store.state.user.token};
    this.block = this.$store.state.block;
    this.search();
  },
  mounted() {
    this.VUE_APP_IOS_URL=process.env.VUE_APP_IOS_URL;
    this.VUE_APP_CDN_URL= process.env.VUE_APP_CDN_URL;
  }
}
</script>

<style scoped>

</style>